/**
 * Pantalla visitada recientemente. A diferencia de favoritos y trending, los
 * recientes NO se guardan en base de datos: viven solo en el localStorage del
 * navegador y se conservan los últimos {RecentService.MAX} por usuario.
 */
export class Recent {
  /** Id del menú (cuando la visita se resolvió contra el menú del usuario) */
  id?: string;
  /** Nombre a mostrar en la card */
  name?: string;
  /** Url interna de la pantalla (sirve además de clave para no duplicar) */
  url?: string;
  /** Clase de ícono (fa, feather, ...) */
  icon?: string;
  /** Imagen: nombre de archivo en belivfiles o URL completa */
  image?: string;
  /** Fecha de la última visita (ISO) */
  visitedAt?: string;
}
